<script>
import { get } from 'vuex-pathify'

export default {
	props: {
		hideIcons: Boolean,
		noBgItem: Boolean,
		dense: Boolean,
		btnClass: [String, Object],
		btnStyle: Object,
		activatorArrowColor: String,
	},
	data() {
		return {
			menuItems: this.$srv('menuLinks'),
			show: this.$srv('AppBarConfig.showLinks'),
			showBrands: false,
			brands: null,
			brandSearch: '',

			hoverBtn: false,
			hoverCarousel: false,
			activeIndex: null,
		}
	},
	computed: {
		filteredBrands() {
			let brands = this.brands
			if (this.brandSearch) {
				brands = brands.filter((x) => x.name.toLowerCase().includes(this.brandSearch.toLowerCase()))
			}
			return brands
		},
		height() {
			if (this.$ssr) return
			return window.innerHeight - 64 - 150
		},
		routeLoading: get('shop/routeLoading'),
	},
	watch: {
		showBrands(val) {
			if (val && !this.brands?.length) {
				this.$shopApi.get({
					url: '/catalog/brands',
					query: { buyables: true },
					onSuccess: ({ data }) => {
						this.brands = data.brands
						this.brands.sort((a, b) => {
							const aName = a.name.toLowerCase()
							const bName = b.name.toLowerCase()
							if (aName < bName) return -1
							if (aName > bName) return 1
							return 0
						})
					},
				})
			} else {
				this.brandSearch = ''
			}
		},
		'$route.fullPath'() {
			this.hoverBtn = false
			this.hoverCarousel = false
		},
	},
}
</script>

<template>
	<div v-if="show && menuItems.length">
		<div v-for="(item, index) of menuItems" :key="index" class="appbar__bottom__menu-items h100">
			<AppBar-Link
				v-if="!item.type || item.type == 'link'"
				:link="item.link"
				:children="item.children"
				:transparent="noBgItem"
				:dense="dense"
				:hide-icons="hideIcons"
				:arrow-color="activatorArrowColor"
				:icon-type="item.iconType"
				:icon="item.icon"
				:icon-html="item.iconHtml"
				:icon-image="item.iconImage"
				:text="item.name"
			/>
			<div
				v-else-if="item.type && item.type == 'imagesCarousel'"
				class="d-flex justify-center align-center h100"
			>
				<div
					@mouseenter="
						() => {
							hoverBtn = true
							activeIndex = index
						}
					"
					@mouseleave="hoverBtn = false"
					class="h100"
				>
					<SafeLink :to="item.link" class="h100 d-flex">
						<AppBar-Button
							class="primary"
							:transparent="noBgItem"
							:dense="dense"
							:text="item.name"
							:hide-icon="hideIcons"
							:icon-type="item.iconType"
							:icon="item.icon"
							:icon-html="item.iconHtml"
							:icon-image="item.iconImage"
							:style="btnStyle"
						>
							<template #bottom>
								<span v-if="item.children">
									<v-icon :color="activatorArrowColor || $vars.primarytext">
										mdi-chevron-down
									</v-icon>
								</span>
							</template>
						</AppBar-Button>
					</SafeLink>
				</div>
				<div class="absolute-wrapper" :class="{ 'is-visible': hoverBtn || hoverCarousel }">
					<div
						class="w100 d-flex justify-center items-center carousel-container"
						@mouseenter="hoverCarousel = true"
						@mouseleave="hoverCarousel = false"
					>
						<div class="w100" style="max-width: 1440px">
							<AppBar-ImagesCarousel
								v-if="(hoverBtn || hoverCarousel) && activeIndex == index"
								:slides-per-page="
									item.children.length > item.slidesPerPage
										? Number(item.slidesPerPage)
										: item.children.length
								"
								:slides="item.children"
							/>
						</div>
					</div>
				</div>
			</div>
			<AppBar-AllBrands
				v-else-if="item.type && item.type == 'allBrands'"
				:transparent="noBgItem"
				:dense="dense"
				:hide-icon="hideIcons"
				:icon-type="item.iconType"
				:icon="item.icon"
				:icon-html="item.iconHtml"
				:icon-image="item.iconImage"
				:text="item.name"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.absolute-wrapper {
	background-color: var(--warning);
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	top: 100%;
	width: 100%;
	left: 0;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.3s ease, transform 0.3s ease;

	&.is-visible {
		opacity: 1;
		transform: translateY(0);
		pointer-events: auto;
	}
}
</style>

